export default {
  translation: {
    // Common
    common: {
      back: 'Zurück',
      session: 'Session',
      topic: 'Thema',
      players: 'Spieler',
      loading: 'Wird geladen...',
      error: 'Fehler',
      copy: 'Kopieren',
      copied: 'Kopiert!',
      remove: 'Entfernen',
      logout: 'Abmelden',
      or: 'oder',
    },

    // Login Page
    login: {
      title: 'Planning Poker',
      subtitle: 'Anmelden um fortzufahren',
      signInWithGitHub: 'Mit GitHub anmelden',
      signInWithGitLab: 'Mit GitLab anmelden',
      info: 'Melde dich mit deinem GitHub oder GitLab Konto an, um Planning Poker zu nutzen',
      errors: {
        loginFailed: 'Anmeldung fehlgeschlagen. Bitte versuche es erneut.',
      },
    },

    // Home Page
    home: {
      title: 'Planning Poker',
      subtitle: 'Echtzeit Scrum Poker für dein Team',
      startSession: 'Session starten',
      asModerator: 'Als Moderator',
      or: 'oder',
      enterCode: 'Session-Code eingeben',
      yourName: 'Dein Name',
      join: 'Beitreten',
      whatIs: 'Was ist Planning Poker?',
      description: 'Planning Poker ist eine agile Schätzmethode, bei der Teams gemeinsam die Komplexität von Aufgaben bewerten.',
      feature1: 'Moderator erstellt eine Session und gibt ein Thema vor',
      feature2: 'Spieler treten mit einem Code bei',
      feature3: 'Alle stimmen gleichzeitig ab',
      feature4: 'Moderator deckt die Karten auf',
      errors: {
        noCode: 'Bitte gib einen Session-Code ein',
        noName: 'Bitte gib deinen Namen ein',
      },
    },

    // Moderator Page
    moderator: {
      title: 'Planning Poker - Moderator',
      createNewSession: 'Neue Session erstellen',
      startSession: 'Session starten',
      sessionCode: 'Session-Code',
      playersCanJoin: 'Spieler können mit diesem Code beitreten',
      copyUrl: 'URL Kopieren',
      openPlayerView: 'Player-Ansicht öffnen',
      currentTopic: 'Aktuelles Thema',
      topicPlaceholder: 'z.B. User Story: Login implementieren',
      setTopic: 'Thema setzen',
      votedCount: '{{count}} von {{total}} haben abgestimmt',
      revealCards: 'Karten aufdecken',
      newRound: 'Neue Runde',
      results: 'Ergebnisse',
      statistics: 'Statistiken',
      average: 'Durchschnitt',
      median: 'Median',
      min: 'Min',
      max: 'Max',
      votes: 'Stimme',
      votes_plural: 'Stimmen',
      waitingForTopic: 'Warte auf Thema...',
      errorCreating: 'Fehler beim Erstellen der Session',
      roundHistory: 'Runden-Historie',
      round: 'Runde',
      noRoundsYet: 'Noch keine abgeschlossenen Runden',
      participants: 'Teilnehmer',
      linkedIssue: 'Verknüpftes Issue',
      optional: 'optional',
      issueUrlPlaceholder: 'z.B. https://github.com/owner/repo/issues/123',
      issueTitlePlaceholder: 'Issue-Titel (optional)',
      linkIssue: 'Issue verknüpfen',
      issueError: 'Fehler beim Verknüpfen des Issues',
      issueHint: 'GitHub oder GitLab Issue-URL eingeben',
      exportResults: 'Ergebnisse exportieren',
      exportCSV: 'CSV exportieren',
      exportJSON: 'JSON exportieren',
      exportPDF: 'PDF exportieren',
      playerMenu: 'Spieler-Menü',
      kickPlayer: 'Entfernen',
      kickConfirm: 'Möchtest du {{name}} wirklich aus der Session entfernen?',
      kickError: 'Fehler beim Entfernen des Spielers',
    },

    // Player Page
    player: {
      title: 'Planning Poker',
      connectingToSession: 'Verbinde mit Session...',
      invalidParams: 'Ungültige Session-Parameter',
      sessionNotFound: 'Session nicht gefunden',
      backToHome: 'Zurück zur Startseite',
      currentTopic: 'Aktuelles Thema',
      waitingForTopic: 'Warte auf Thema...',
      chooseCard: 'Wähle deine Karte',
      yourVote: 'Deine Stimme',
      you: 'Du',
      resultsTitle: 'Ergebnisse',
      connectionLost: 'Verbindung zum Server verloren',
      roundHistory: 'Runden-Historie',
      round: 'Runde',
      noRoundsYet: 'Noch keine abgeschlossenen Runden',
      linkedIssue: 'Verknüpftes Issue',
    },

    // Issue Search
    issueSearch: {
      assignedToMe: 'Mir zugewiesen',
      createdByMe: 'Von mir erstellt',
    },

    // Footer
    footer: {
      impressum: 'Impressum',
      datenschutz: 'Datenschutz',
      spielanleitung: 'Spielanleitung',
      faq: 'FAQ',
      allRightsReserved: 'Alle Rechte vorbehalten.',
    },

    // SEO / Meta Tags
    seo: {
      home: {
        title: 'Planning Poker - Echtzeit Scrum Poker für agile Teams',
        description: 'Planning Poker ist eine agile Schätzmethode für Teams. Erstelle Sessions, lade Teammitglieder ein und schätze gemeinsam die Komplexität von Aufgaben in Echtzeit.',
        keywords: 'Planning Poker, Scrum Poker, Agile Estimation, Sprint Planning, Team Collaboration, Scrum, Agile, Story Points',
      },
      impressum: {
        title: 'Impressum - Planning Poker',
        description: 'Impressum und rechtliche Informationen zu Planning Poker gemäß § 5 TMG.',
      },
      datenschutz: {
        title: 'Datenschutzerklärung - Planning Poker',
        description: 'Datenschutzerklärung für Planning Poker. Informationen zur Datenverarbeitung gemäß DSGVO.',
      },
      spielanleitung: {
        title: 'Spielanleitung - Planning Poker',
        description: 'Ausführliche Anleitung zur Verwendung von Planning Poker. Lerne, wie du Sessions erstellst, Teammitglieder einlädst und effektiv Story Points schätzt.',
        keywords: 'Planning Poker Anleitung, How to Play, Scrum Poker Tutorial, Agile Schätzung, Story Points, Sprint Planning Guide',
      },
      faq: {
        title: 'FAQ - Häufig gestellte Fragen - Planning Poker',
        description: 'Häufig gestellte Fragen zu Planning Poker. Finde schnelle Antworten auf die wichtigsten Fragen zur Nutzung, Sessions, Karten und mehr.',
        keywords: 'Planning Poker FAQ, Häufige Fragen, Planning Poker Hilfe, Scrum Poker Fragen, Agile Estimation FAQ',
      },
      siteName: 'Planning Poker',
      author: 'Planning Poker Team',
    },

    // Impressum Page
    impressum: {
      title: 'Impressum',
      provider: 'Angaben gemäß § 5 TMG',
      companyName: 'Musterfirma GmbH',
      street: 'Musterstraße 123',
      cityZip: '12345 Musterstadt',
      country: 'Deutschland',
      contact: 'Kontakt',
      phone: 'Telefon',
      email: 'E-Mail',
      website: 'Webseite',
      representative: 'Vertreten durch',
      representativeName: 'Max Mustermann (Geschäftsführer)',
      registrationTitle: 'Registereintrag',
      registrationCourt: 'Registergericht',
      registrationNumber: 'Registernummer',
      vatId: 'Umsatzsteuer-ID',
      responsibleForContent: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
      responsibleName: 'Max Mustermann',
      disputeResolution: 'Streitschlichtung',
      disputeText: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
      liability: 'Haftungsausschluss',
      liabilityContent: 'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.',
      liabilityLinks: 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.',
    },

    // Datenschutz Page
    datenschutz: {
      title: 'Datenschutzerklärung',
      lastUpdated: 'Stand',
      overview: 'Überblick',
      overviewText: 'Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.',
      responsibleParty: 'Verantwortliche Stelle',
      dataCollection: 'Datenerfassung auf dieser Website',
      cookies: 'Cookies',
      cookiesText: 'Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Die meisten der von uns verwendeten Cookies sind sogenannte Session-Cookies, die nach dem Schließen des Browsers automatisch gelöscht werden.',
      serverLogs: 'Server-Log-Dateien',
      serverLogsText: 'Bei jedem Zugriff auf unsere Website werden automatisch Informationen in Server-Log-Dateien gespeichert, die Ihr Browser automatisch übermittelt. Dies sind:',
      browserType: 'Browsertyp und Browserversion',
      browserVersion: 'Verwendetes Betriebssystem',
      operatingSystem: 'Verwendetes Betriebssystem',
      referrerUrl: 'Referrer URL',
      hostname: 'Hostname des zugreifenden Rechners',
      accessTime: 'Uhrzeit der Serveranfrage',
      ipAddress: 'IP-Adresse',
      authentication: 'Authentifizierung (GitHub/GitLab)',
      authText: 'Wenn Sie sich über GitHub oder GitLab anmelden, erfassen wir folgende Daten von Ihrem GitHub/GitLab-Profil:',
      authName: 'Name',
      authEmail: 'E-Mail-Adresse',
      authAvatar: 'Profilbild',
      authUsername: 'Benutzername',
      yourRights: 'Ihre Rechte',
      rightsIntro: 'Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren.',
      rightAccess: 'Auskunft',
      rightAccessText: 'Sie haben das Recht, Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen.',
      rightCorrection: 'Berichtigung',
      rightCorrectionText: 'Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogener Daten zu verlangen.',
      rightDeletion: 'Löschung',
      rightDeletionText: 'Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen.',
      rightRestriction: 'Einschränkung der Verarbeitung',
      rightRestrictionText: 'Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.',
      rightPortability: 'Datenübertragbarkeit',
      rightPortabilityText: 'Sie haben das Recht, Ihre personenbezogenen Daten in einem strukturierten, gängigen Format zu erhalten.',
      rightObjection: 'Widerspruch',
      rightObjectionText: 'Sie haben das Recht, der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen.',
      dataSecurity: 'Datensicherheit',
      dataSecurityText: 'Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um eine 256-Bit-Verschlüsselung. Falls Ihr Browser keine 256-Bit-Verschlüsselung unterstützt, greifen wir stattdessen auf 128-Bit-v3-Technologie zurück.',
      thirdParty: 'Dienste von Drittanbietern',
      thirdPartyText: 'Wir nutzen folgende Dienste von Drittanbietern:',
      supabaseText: 'Für die Authentifizierung und Datenspeicherung nutzen wir Supabase. Weitere Informationen finden Sie in der Datenschutzerklärung von Supabase: https://supabase.com/privacy',
      sentryText: 'Für die Fehlererfassung und -überwachung nutzen wir Sentry. Weitere Informationen finden Sie in der Datenschutzerklärung von Sentry: https://sentry.io/privacy/',
      contact: 'Kontakt',
      contactText: 'Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, Sperrung oder Löschung von Daten wenden Sie sich bitte an die im Impressum angegebene Adresse.',
    },

    // Spielanleitung Page
    spielanleitung: {
      title: 'Spielanleitung',
      subtitle: 'Wie funktioniert Planning Poker?',
      intro: 'Planning Poker ist eine Schätzmethode für agile Teams, die dabei hilft, den Aufwand von User Stories gemeinsam zu bewerten. Diese Anleitung führt dich durch alle Schritte.',

      // Für Moderatoren
      forModerators: 'Für Moderatoren',
      moderatorIntro: 'Als Moderator bist du für die Organisation und Steuerung der Planning Poker Session verantwortlich.',

      step1Title: 'Schritt 1: Session erstellen',
      step1Text: 'Klicke auf der Startseite auf "Session starten". Du wirst automatisch als Moderator angemeldet und erhältst einen einzigartigen 6-stelligen Session-Code.',

      step2Title: 'Schritt 2: Team einladen',
      step2Text: 'Teile den Session-Code oder die vollständige URL mit deinem Team. Spieler können den Code auf der Startseite eingeben oder direkt über den Link beitreten.',

      step3Title: 'Schritt 3: Thema festlegen',
      step3Text: 'Gib das aktuelle Schätzungsthema ein (z.B. "User Story: Login-Funktion implementieren"). Optional kannst du auch ein GitHub oder GitLab Issue verknüpfen.',

      step4Title: 'Schritt 4: Abstimmung starten',
      step4Text: 'Sobald alle Spieler ihre Karten gewählt haben, siehst du die Anzahl der abgegebenen Stimmen. Klicke auf "Karten aufdecken", um die Ergebnisse zu zeigen.',

      step5Title: 'Schritt 5: Ergebnisse diskutieren',
      step5Text: 'Du siehst alle Stimmen, den Durchschnitt, Median sowie Min/Max-Werte. Diskutiere Abweichungen im Team und starte bei Bedarf eine neue Runde.',

      step6Title: 'Schritt 6: Nächste Runde',
      step6Text: 'Klicke auf "Neue Runde", um das nächste Thema zu schätzen. Die Historie aller Runden wird automatisch gespeichert.',

      // Für Spieler
      forPlayers: 'Für Spieler',
      playerIntro: 'Als Spieler nimmst du an der Schätzung teil und gibst deine Einschätzung zur Komplexität der Aufgaben ab.',

      playerStep1Title: 'Schritt 1: Session beitreten',
      playerStep1Text: 'Gib auf der Startseite den 6-stelligen Session-Code und deinen Namen ein. Klicke auf "Beitreten", um der Session beizutreten.',

      playerStep2Title: 'Schritt 2: Thema lesen',
      playerStep2Text: 'Lies das vom Moderator festgelegte Thema aufmerksam durch. Falls ein Issue verknüpft ist, kannst du es direkt öffnen.',

      playerStep3Title: 'Schritt 3: Karte wählen',
      playerStep3Text: 'Wähle eine Karte aus, die deiner Einschätzung der Komplexität entspricht. Die Fibonacci-Sequenz (1, 2, 3, 5, 8, 13, 21) wird standardmäßig verwendet.',

      playerStep4Title: 'Schritt 4: Auf Aufdeckung warten',
      playerStep4Text: 'Warte, bis alle Spieler gewählt haben. Der Moderator deckt dann die Karten auf und zeigt die Ergebnisse.',

      playerStep5Title: 'Schritt 5: Diskussion',
      playerStep5Text: 'Diskutiere mit deinem Team über die verschiedenen Schätzungen, besonders bei großen Abweichungen.',

      // Karten-Werte
      cardValues: 'Karten-Werte',
      cardValuesText: 'Planning Poker verwendet typischerweise die Fibonacci-Sequenz, um die zunehmende Unsicherheit bei größeren Aufgaben zu berücksichtigen:',
      cardValue1: '1, 2, 3: Kleine, einfache Aufgaben',
      cardValue2: '5, 8: Mittlere Aufgaben mit moderater Komplexität',
      cardValue3: '13, 21: Große, komplexe Aufgaben',
      cardValue4: '?: Unsicherheit, mehr Informationen benötigt',
      cardValue5: '☕: Pause benötigt',

      // Tipps
      tips: 'Tipps für erfolgreiche Schätzungen',
      tip1: 'Diskutiert die Anforderungen ausführlich, bevor ihr schätzt',
      tip2: 'Vermeidet "Anchoring" - zeigt die Karten gleichzeitig',
      tip3: 'Bei großen Abweichungen: Lasst die höchste und niedrigste Schätzung ihre Sichtweise erklären',
      tip4: 'Nutzt die Pause-Karte (☕) wenn eine Diskussion zu lang wird',
      tip5: 'Teilt sehr große Aufgaben (21+) in kleinere Stories auf',
      tip6: 'Die ?-Karte zeigt an, dass mehr Informationen benötigt werden',

      // Features
      features: 'Weitere Features',
      feature1Title: 'Runden-Historie',
      feature1Text: 'Alle abgeschlossenen Runden werden gespeichert und können jederzeit eingesehen werden.',
      feature2Title: 'Issue-Verknüpfung',
      feature2Text: 'Verknüpfe GitHub oder GitLab Issues direkt mit deinen Schätzungen.',
      feature3Title: 'Echtzeit-Updates',
      feature3Text: 'Alle Änderungen werden in Echtzeit an alle Teilnehmer übertragen.',
      feature4Title: 'Dark Mode',
      feature4Text: 'Wähle zwischen hellem und dunklem Design für angenehmes Arbeiten.',
      feature5Title: 'Mehrsprachig',
      feature5Text: 'Die Anwendung ist in Deutsch und Englisch verfügbar.',
    },

    // FAQ Page
    faq: {
      title: 'Häufig gestellte Fragen',
      subtitle: 'Finde schnelle Antworten auf die wichtigsten Fragen zu Planning Poker',
      moreHelp: 'Brauchst du weitere Hilfe?',
      moreHelpText: 'Besuche unsere ausführliche Spielanleitung für detaillierte Informationen zur Nutzung von Planning Poker.',
      viewGuide: 'Zur Spielanleitung',

      q1: 'Was ist Planning Poker?',
      a1: 'Planning Poker (auch Scrum Poker genannt) ist eine agile Schätzmethode, die von Entwicklungsteams verwendet wird, um den Aufwand oder die relative Größe von Aufgaben in der Softwareentwicklung zu schätzen. Die Methode nutzt die Weisheit der Gruppe und vermeidet kognitive Verzerrungen wie Anker-Effekte.',

      q2: 'Wie starte ich eine Planning Poker Session?',
      a2: 'Klicke auf der Startseite auf "Session starten". Du wirst als Moderator angemeldet und erhältst einen eindeutigen 6-stelligen Session-Code. Teile diesen Code mit deinem Team, damit sie beitreten können.',

      q3: 'Kann ich ohne Anmeldung teilnehmen?',
      a3: 'Ja! Als Spieler kannst du ohne Anmeldung teilnehmen - du benötigst nur den Session-Code und deinen Namen. Nur Moderatoren müssen sich mit GitHub oder GitLab anmelden, um Sessions zu erstellen.',

      q4: 'Welche Kartenwerte werden verwendet?',
      a4: 'Wir verwenden die modifizierte Fibonacci-Sequenz: 1, 2, 3, 5, 8, 13, 21. Zusätzlich gibt es Sonderkarten:\n• ? (Fragezeichen) - Wenn du unsicher bist oder mehr Informationen benötigst\n• ☕ (Kaffeetasse) - Wenn du eine Pause brauchst\n\nDie Fibonacci-Sequenz spiegelt die zunehmende Unsicherheit bei größeren Aufgaben wider.',

      q5: 'Wie viele Personen können an einer Session teilnehmen?',
      a5: 'Es gibt keine feste Obergrenze, aber für optimale Ergebnisse empfehlen wir 3-10 Teilnehmer. Dies entspricht der idealen Größe für Scrum-Teams und ermöglicht produktive Diskussionen.',

      q6: 'Kann ich GitHub oder GitLab Issues verknüpfen?',
      a6: 'Ja! Als Moderator kannst du GitHub oder GitLab Issues direkt mit deinen Schätzungen verknüpfen. Gib einfach die Issue-URL in das entsprechende Feld ein. Die Issue-Details werden dann für alle Teilnehmer sichtbar angezeigt.',

      q7: 'Was passiert, wenn jemand während der Session die Verbindung verliert?',
      a7: 'Planning Poker nutzt Echtzeit-Synchronisation. Wenn jemand die Verbindung verliert und die Seite neu lädt, kann er einfach mit demselben Namen erneut der Session beitreten. Die aktuelle Runde und alle vorherigen Ergebnisse bleiben erhalten.',

      q8: 'Werden meine Schätzungen gespeichert?',
      a8: 'Ja, alle abgeschlossenen Runden werden in der Session-Historie gespeichert und können jederzeit eingesehen werden. Die Daten bleiben für die Dauer der Session verfügbar. Aus Datenschutzgründen werden Sessions nach einer gewissen Inaktivität automatisch gelöscht.',

      q9: 'Kann ich Planning Poker im Dark Mode verwenden?',
      a9: 'Ja! Klicke einfach auf das Mond/Sonne-Symbol oben rechts, um zwischen hellem und dunklem Design zu wechseln. Deine Präferenz wird für zukünftige Besuche gespeichert.',

      q10: 'Was bedeuten die Statistiken nach der Abstimmung?',
      a10: 'Nach dem Aufdecken der Karten siehst du mehrere Statistiken:\n• Durchschnitt: Das arithmetische Mittel aller Schätzungen\n• Median: Der mittlere Wert (besonders nützlich bei Ausreißern)\n• Min/Max: Die niedrigste und höchste Schätzung\n\nGroße Abweichungen zwischen Min und Max deuten darauf hin, dass das Team unterschiedliche Vorstellungen von der Aufgabe hat und eine Diskussion hilfreich wäre.',
    },
  },
}
